import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export const sharedStyleClass = StyleClass(`quickSaveIcon_workflowNodes_shared`, {
    textAlign: "center",
    fontSize: "44px",
    ":active": {
        color: `gold`,
    },
});
